import ReactDOMServer from 'react-dom/server';

export const print = ({ ref, component, id }) => {
  if (component) {
    runPrint(ReactDOMServer.renderToStaticMarkup(component));
  } else if (ref) {
    runPrint(ref.current.innerHTML);
  } else if (id) {
    runPrint(document.getElementById('id').innerHTML);
  }
};

const runPrint = async (printContent) => {
  const printWindow = window.open('', '');

  // Get all styles from the main document
  const styles = Array.from(document.styleSheets)
    .map((styleSheet) => {
      try {
        return Array.from(styleSheet.cssRules)
          .map((rule) => rule.cssText)
          .join('\n');
      } catch (e) {
        console.warn(
          'Access to stylesheet %s is denied. Ignoring.',
          styleSheet.href,
        );
        return '';
      }
    })
    .join('\n');

  printWindow.document.write(`
    <html>
      <head>
        <title>Imprimir</title>
          <style>
            ${styles}
          </style>
        </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);

  printWindow.document.close();

  // Wait for images to load
  const images = printWindow.document.images;
  const promises = Array.from(images).map((img) => {
    return new Promise((resolve) => {
      img.onload = img.onerror = resolve;
    });
  });

  await Promise.all(promises);

  printWindow.print();
  printWindow.close();
};
